(function(){
  if(!window.DB_OFFER) return;
  const reduce=matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---------- gallery ---------- */
  const track=document.getElementById('track'), slides=track.children.length, thumbs=[...document.querySelectorAll('.db-thumbs button')], cap=document.getElementById('cap'), main=document.getElementById('mainSlide');
  let cur=0;
  function goTo(i){
    cur=(i+slides)%slides;
    track.style.transform='translateX(-'+(cur*100)+'%)';
    thumbs.forEach(b=>b.setAttribute('aria-selected',+b.dataset.i===cur));
    cap.textContent=thumbs[cur].dataset.cap; cap.hidden=!cap.textContent;
    thumbs[cur].scrollIntoView({block:'nearest',inline:'nearest',behavior:reduce?'auto':'smooth'});
  }
  thumbs.forEach(b=>b.addEventListener('click',()=>goTo(+b.dataset.i)));
  // click the photo to slide to the next one; swipe on touch
  let sx=null, moved=false;
  main.addEventListener('pointerdown',e=>{sx=e.clientX;moved=false;});
  main.addEventListener('pointermove',e=>{if(sx!==null&&Math.abs(e.clientX-sx)>8) moved=true;});
  main.addEventListener('pointerup',e=>{
    if(sx===null) return;
    const dx=e.clientX-sx; sx=null;
    if(moved&&Math.abs(dx)>40){ goTo(dx<0?cur+1:cur-1); return; }
    if(moved) return;
    // tapping past the last photo takes you to the plan picker
    if(cur===slides-1 && matchMedia('(max-width: 900px)').matches){ document.getElementById('cta').scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'}); goTo(0); }
    else goTo(cur+1);
  });
  main.addEventListener('pointercancel',()=>{sx=null;});
  main.addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='Enter'||e.key===' '){e.preventDefault();goTo(cur+1);} if(e.key==='ArrowLeft'){e.preventDefault();goTo(cur-1);}});

  /* ---------- offer state (subscription-first) ---------- */
  const D=window.DB_OFFER, money=n=>'$'+(n/100).toFixed(2);
  const planOf=(p)=>p.plans&&p.plans.length?p.plans[0]:null;
  const subPrice=(p)=>planOf(p)?planOf(p).price:Math.round(p.price*(100-D.discount)/100);
  const preview=!planOf(D.triple)&&!planOf(D.single);
  const OFFER={
    sub:  { triple:{price:subPrice(D.triple),was:D.triple.price,meta:'6-month supply for one person',renew:'Renews '+D.cadence.triple+'. Skip, pause or cancel from your account anytime.',note:'3-pack · '+D.cadence.triple,variant:D.triple.variant,planId:planOf(D.triple)?planOf(D.triple).id:'',available:D.triple.available},
            single:{price:subPrice(D.single),was:D.single.price,meta:'2-month supply for one person',renew:'Renews '+D.cadence.single+'. Skip, pause or cancel from your account anytime.',note:'Single tube · '+D.cadence.single,variant:D.single.variant,planId:planOf(D.single)?planOf(D.single).id:'',available:D.single.available} },
    once: { triple:{price:D.triple.price,was:null,meta:'6-month supply for one person',renew:'One-time purchase. 30-day returns on unopened items.',note:'3-pack · one-time',variant:D.triple.variant,planId:'',available:D.triple.available},
            single:{price:D.single.price,was:null,meta:'2-month supply for one person',renew:'One-time purchase. 30-day returns on unopened items.',note:'Single tube · one-time',variant:D.single.variant,planId:'',available:D.single.available} }
  };
  const modes=[...document.querySelectorAll('.db-mode')], plans=[...document.querySelectorAll('.db-plan')];
  const ctaLabel=document.getElementById('ctaLabel'), ctaPrice=document.getElementById('ctaPrice'), fine=document.getElementById('fine'), assure=document.getElementById('assure');
  const stickyPrice=document.getElementById('stickyPrice'), stickyPick=document.getElementById('stickyPick'), stickyCta=document.getElementById('stickyCta');
  let mode='once', plan=(window.DB_OFFER.showPack===false?'single':'triple'), qty=1;
  if(window.DB_OFFER.showPack===false){
    document.querySelectorAll('[data-plan="triple"]').forEach(x=>{x.hidden=true;});
    if(stickyPick) stickyPick.querySelectorAll('option[value$=":triple"]').forEach(o=>o.remove());
  }

  const FREE_SHIP=(window.DB_OFFER&&window.DB_OFFER.freeShip)||30;
  function render(){
    plans.forEach(b=>{
      const o=OFFER[mode][b.dataset.plan];
      b.querySelector('[data-f=price]').textContent=money(o.price);
      const was=b.querySelector('[data-f=was]'); was.textContent=o.was?money(o.was):''; was.hidden=!o.was;
      b.querySelector('[data-f=meta]').textContent=o.meta;
      b.setAttribute('aria-checked', b.dataset.plan===plan);
      const sh=b.querySelector('.db-ship'); if(sh) sh.hidden = !(o.price >= FREE_SHIP);
    });
    modes.forEach(m=>m.setAttribute('aria-selected', m.dataset.mode===mode));
    const o=OFFER[mode][plan];
    ctaLabel.textContent = mode==='sub' ? 'Start subscription' : 'Add to cart';
    ctaPrice.textContent = money(o.price*qty);
    document.getElementById('qOut').value=qty; document.getElementById('qOut').textContent=qty;
    document.getElementById('qMinus').disabled = qty<=1;
    const qi=document.querySelector('#db-product-form input[name="quantity"]'); if(qi) qi.value=qty;
    fine.textContent = o.renew;
    stickyPrice.textContent=money(o.price*qty); stickyPick.value=mode+':'+plan;
    stickyCta.textContent = mode==='sub' ? 'Subscribe' : 'Add to cart';
    const vid=document.getElementById('db-variant-id'), sp=document.getElementById('db-selling-plan'), cta=document.getElementById('cta'), pv=document.getElementById('dbPreview');
    vid.value=o.variant;
    if(mode==='sub'&&o.planId){ sp.value=o.planId; sp.disabled=false; } else { sp.value=''; sp.disabled=true; }
    if(!o.available){ cta.disabled=true; ctaLabel.textContent='Sold out'; }
    else { cta.disabled=false; }
    if(pv) pv.hidden=!(mode==='sub'&&preview);
  }
  modes.forEach(m=>m.addEventListener('click',()=>{mode=m.dataset.mode;render();}));
  stickyPick.addEventListener('change',()=>{const [m,p]=stickyPick.value.split(':'); mode=m; plan=p; render();});
  plans.forEach(b=>b.addEventListener('click',()=>{plan=b.dataset.plan;render();}));
  document.getElementById('qMinus').addEventListener('click',()=>{qty=Math.max(1,qty-1);render();});
  document.getElementById('qPlus').addEventListener('click',()=>{qty=Math.min(24,qty+1);render();});
  render();
  document.querySelectorAll('[data-pick]').forEach(el=>el.addEventListener('click',e=>{
    e.preventDefault(); const [m,p]=el.dataset.pick.split(':'); mode=m; plan=p; render();
    document.getElementById('buy').scrollIntoView({behavior:reduce?'auto':'smooth',block:'center'});
  }));
  const toast=document.getElementById('toast'); let toastT;
  const form=document.getElementById('db-product-form'), err=document.getElementById('dbFormError');
  form.addEventListener('submit',e=>{
    e.preventDefault();
    const cta=document.getElementById('cta'); if(cta.disabled) return;
    cta.classList.add('db-loading'); err.hidden=true;
    const fd=new FormData(form);
    const drawer=document.querySelector('cart-drawer')||document.querySelector('cart-notification');
    if(drawer&&drawer.getSectionsToRender){ fd.append('sections', drawer.getSectionsToRender().map(s=>s.id)); fd.append('sections_url', window.location.pathname); if(drawer.setActiveElement) drawer.setActiveElement(document.activeElement); }
    fetch((window.routes&&window.routes.cart_add_url)||'/cart/add', {method:'POST', body:fd, headers:{'Accept':'application/json','X-Requested-With':'XMLHttpRequest'}})
      .then(r=>r.json()).then(res=>{
        cta.classList.remove('db-loading');
        if(res.status){ err.textContent=res.description||res.message||'Could not add to cart.'; err.hidden=false; return; }
        if(drawer&&drawer.renderContents){
          if(window.publish&&window.PUB_SUB_EVENTS){ publish(PUB_SUB_EVENTS.cartUpdate,{source:'product-form',productVariantId:fd.get('id'),cartData:res}); }
          drawer.renderContents(res);
          drawer.classList.remove('is-empty');
        } else { window.location=(window.routes&&window.routes.cart_url)||'/cart'; }
      }).catch(()=>{ cta.classList.remove('db-loading'); err.textContent='Could not add to cart. Please try again.'; err.hidden=false; });
  });

  /* sticky bar once the panel scrolls away */
  const bar=document.getElementById('stickybar'), buy=document.getElementById('buy');
  new IntersectionObserver(([e])=>bar.classList.toggle('db-show',!e.isIntersecting&&e.boundingClientRect.top<0),{threshold:0}).observe(buy);

  /* reveal on scroll (resting state visible) */
  if(!reduce){
    const io=new IntersectionObserver(es=>es.forEach(e=>{if(e.isIntersecting){e.target.classList.add('db-go');io.unobserve(e.target);}}),{rootMargin:'0px 0px -8% 0px'});
    document.querySelectorAll('.db-reveal').forEach((el,i)=>{el.style.animationDelay=(i%3)*70+'ms';io.observe(el);});
  }
})();